import Color from 'tinycolor2';

const hexToSwiftColorLiteral = (hexColorString: string): string => {
  const { r, g, b, a } = Color(hexColorString).toRgb();
  const rFixed = (r / 255.0).toFixed(5);
  const gFixed = (g / 255.0).toFixed(5);
  const bFixed = (b / 255.0).toFixed(5);
  return `#colorLiteral(red: ${rFixed}, green: ${gFixed}, blue: ${bFixed}, alpha: ${a})`;
};

export default hexToSwiftColorLiteral;



// WEBPACK FOOTER //
// ../kibble/tokens/formats/utils/hexToSwiftColorLiteral.ts